import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-lock.tsx
/**
* icon.24.lock
*
* Keywords: padlock, security, closed, protection, secure, privacy, restricted, shackle
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAgMTJIOC41YS41LjUgMCAwIDAtLjUuNXY0YS41LjUgMCAwIDAgLjUuNWg3YS41LjUgMCAwIDAgLjUtLjV2LTRhLjUuNSAwIDAgMC0uNS0uNXptMS0xaC0xVjlhMiAyIDAgMSAxIDQgMHYyem0xLTVhMyAzIDAgMCAxIDMgM3YyaC41YTEuNSAxLjUgMCAwIDEgMS41IDEuNXY0YTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtN0ExLjUgMS41IDAgMCAxIDcgMTYuNXYtNEExLjUgMS41IDAgMCAxIDguNSAxMUg5VjlhMyAzIDAgMCAxIDMtMyIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-9578
*/
const Icon24Lock = memo(function Icon24Lock(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M10 12H8.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5zm1-1h-1V9a2 2 0 1 1 4 0v2zm1-5a3 3 0 0 1 3 3v2h.5a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 7 16.5v-4A1.5 1.5 0 0 1 8.5 11H9V9a3 3 0 0 1 3-3",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Lock };

//# sourceMappingURL=icon-24-lock.js.map